// 🚌 BUS — Minimal event bus drop-killer
// Usado para comunicar views ↔ comps sin prop drilling ni CustomEvents DOM.
// API: bus.on(event, cb) → off()   bus.emit(event, detail)

const listeners = new Map()

export const bus = {
  on(event, cb) {
    if (!listeners.has(event)) listeners.set(event, new Set())
    const set = listeners.get(event)
    set.add(cb)
    return () => set.delete(cb)
  },

  emit(event, detail = {}) {
    const set = listeners.get(event)
    if (!set) return
    for (const cb of set) {
      try { cb(detail) }
      catch (err) { console.error('[drop-killer] bus handler error', event, err) }
    }
  },

  off(event, cb) {
    listeners.get(event)?.delete(cb)
  },
}

export default bus
